/* eslint-disable react/react-in-jsx-scope */
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ResetPassword from "../pages/Authentication/ResetPassword"

//  // Inner Authentication
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword"
import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPassword2"
import Login1 from "../pages/AuthenticationInner/Login"
import Login2 from "../pages/AuthenticationInner/Login2"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2"
import Register2 from "../pages/AuthenticationInner/Register2"
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification"
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2"
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification"
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2"
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail"
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2"

// Dashboard
import DashboardSaas from "../pages/Dashboard-saas/index"

//Tables
import Demo from "../pages/Tables/PublicacaoTeste"
import QualificacaoLead from "../pages/Tables/QualificacaoLead"

//Qualificação
import QualificacaoLista from "../pages/Leads/Qualificacao"
import QualificacaoDetail from "../pages/Leads/Qualificacao/qualificacao-detail"

import EmpresasMonitoradas from "pages/Leads/Empresas/EmpresasMonitoradas"
import Monitoramento from "pages/Leads/Monitoramento/Monitoramento"
import Timeline from "pages/Leads/Qualificacao/linhaDoTempo/Timeline"
import DashboardProcessos from "../pages/Leads/Qualificacao/dashboard-processos"
import Seguradoras from "../pages/Leads/Seguradoras"
import SeguradoraTemplates from "../pages/Leads/Seguradoras/Templates"
import Corretoras from "../pages/Leads/Corretoras"
import Parceiros from "../pages/Leads/Parceiros"
import ParceiroTemplates from "../pages/Leads/Parceiros/Templates"

//Pages
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"
import PagesComingsoon from "../pages/Utility/pages-comingsoon"
import PagesFaqs from "../pages/Utility/pages-faqs"
import PagesMaintenance from "../pages/Utility/pages-maintenance"
import PagesPricing from "../pages/Utility/pages-pricing"
import PagesStarter from "../pages/Utility/pages-starter"
import PagesTimeline from "../pages/Utility/pages-timeline"

//Contacts
import PainelRaspagemPage from "pages/Leads/PainelRaspagem"
import ResultadosPublicacaoFinal from "pages/Leads/PublicacoesFinal"
import ResultadosPublicacaoGeral from "pages/Leads/PublicacoesGeral"
import ContactsList from "../pages/Contacts/ContactList/contacts-list"
import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile"
import ContactsGrid from "../pages/Contacts/contacts-grid"

const authProtectedRoutes = [
  { path: "/dashboard-saas", component: DashboardSaas },

  //profile
  { path: "/profile", component: UserProfile },

  // Contacts
  { path: "/contacts-grid", component: ContactsGrid },
  { path: "/contacts-list", component: ContactsList, roles: ["super_admin", "admin"] },
  { path: "/contacts-profile", component: ContactsProfile },
  { path: "/qualificacao-old", component: QualificacaoLead },
  { path: "/demo", component: Demo },

  //Qualificação
  { path: "/qualificacao", component: QualificacaoLista },
  { path: "/qualificacao-detail/:id", component: QualificacaoDetail },
  { path: "/cockpit", component: DashboardProcessos },
  { path: "/monitoramento", component: Monitoramento },
  { path: "/empresas-monitoradas", component: EmpresasMonitoradas },
  { path: "/parceiros/:id/templates", component: ParceiroTemplates },
  { path: "/parceiros", component: Parceiros },
  { path: "/seguradoras", component: Seguradoras },
  { path: "/seguradoras/:id/templates", component: SeguradoraTemplates },
  { path: "/corretoras", component: Corretoras },
  {
    path: "/resultados-publicacao-final",
    component: ResultadosPublicacaoFinal,
  },
  {
    path: "/resultados-publicacao-geral",
    component: ResultadosPublicacaoGeral,
  },
  { path: "/painel-raspagem", component: PainelRaspagemPage },
  { path: "/linha-do-tempo/:id", component: Timeline },

  // Maps
  //Utility
  { path: "/pages-starter", component: PagesStarter },
  { path: "/pages-timeline", component: PagesTimeline },
  { path: "/pages-faqs", component: PagesFaqs },
  { path: "/pages-pricing", component: PagesPricing },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  // { path: "/", exact: true, component: () => <Redirect to="/dashboard-saas" /> },
  { path: "/", exact: true, component: () => <Redirect to="/qualificacao" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  // { path: "/register", component: Register },
  { path: "/reset-password/:token", component: ResetPassword },

  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },

  // Authentication Inner
  { path: "/pages-login", component: Login1 },
  { path: "/pages-login-2", component: Login2 },
  // { path: "/pages-register", component: Register1 },
  { path: "/pages-register-2", component: Register2 },
  { path: "/page-recoverpw", component: Recoverpw },
  { path: "/page-recoverpw-2", component: Recoverpw2 },
  { path: "/pages-forgot-pwd", component: ForgetPwd1 },
  { path: "/auth-recoverpw-2", component: ForgetPwd2 },
  { path: "/auth-lock-screen", component: LockScreen },
  { path: "/auth-lock-screen-2", component: LockScreen2 },
  { path: "/page-confirm-mail", component: ConfirmMail },
  { path: "/page-confirm-mail-2", component: ConfirmMail2 },
  { path: "/auth-email-verification", component: EmailVerification },
  { path: "/auth-email-verification-2", component: EmailVerification2 },
  { path: "/auth-two-step-verification", component: TwostepVerification },
  { path: "/auth-two-step-verification-2", component: TwostepVerification2 },
]

export { authProtectedRoutes, publicRoutes }

